import React from 'react';
import PropTypes from 'prop-types';
import { WidgetTitle, WidgetLink } from './styles';

export default class MapSenateWidget extends React.PureComponent {
	render() {
		return <>
			<WidgetTitle className={this.props.className}>Senátní volby</WidgetTitle>
			{ this.props.children }
			<WidgetLink href={this.props.link}>
				Přehled všech obvodů
			</WidgetLink>
		</>
	}
}

MapSenateWidget.propTypes = {
	link: PropTypes.string.isRequired
};
